var map = {
  "./Spitcast.png": "8",
  "./Surfline.png": "837",
  "./Surfline.svg": "858",
  "./map.svg": "146",
  "./swell-marker.svg": "254",
  "./wave.jpg": "240",
  "./wave.png": "692",
  "./wave.svg": "59",
  "./wind-marker.svg": "201"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function() { return Object.keys(map); };
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 190;
